export class Auth {
  client_id: string;
  managerId: string;
  grant_type: string;
  username: string;
  password: string;
  passcode?: string;
}

export class RefreshAuth {
  client_id: string;
  managerId: string;
  grant_type: string;
  refresh_token: string;
}

export class AuthRequestReset {
  siteId: string;
  emailAddress: string;
  clientId: string;
  managerId: string;
}

export class AuthReset {
  passwordToken: string;
  userId: string;
  newPassword: string;
  fromInvitation: boolean;
  siteId: number;
  clientId: string;
  managerId: string;
}

export interface ChangedPasswordVM {
  oldPassword: string;
  newPassword: string;
  confirmedPassword: string;
  siteId: number;
}

export interface TwoFactorTypeVM {
  twoFactorEnabled: boolean;
  twoFactorType: number;
  managerCode: string;
  siteId: number;
}

export enum TFASteps {
  START_SET_TYPE = 0,
  EMAIL_CONFIRM = 1,
  SMS_REQUEST = 2,
  SMS_VERIFY = 3,
  SMS_CONFIRM = 4,
}

export interface IdentityUser {
    identityId: number;
    userId: number;
    name: string;
    username: string;
    managerId: number;
    managerName: string;
}

export type UserScope =
  | 'All'
  | 'Authorizer'
  | 'Online Access'
  | 'Portfolio Administration'
  | 'Investment Management Viewer';

export interface IClaim {
  ['aud']: string;
  ['client-scope']: string;
  ['exp']: number;
  ['given_name']: string;
  ['iss']: string;
  ['managerName']: string;
  ['nbf']: number;
  ['primarygroupsid']: number;
  ['primarysid']: number;
  ['role']: string;
  ['sub']: string;
  ['unique_name']: string;
  ['user-scope']: UserScope[];
}

export enum ManagerIDs {
  RIVAL = 5361,
  RUTHERFORDREDE = 338597,
  INVESTNOW = 4542,
  CLEARY = 61106,
  BLISSETT = 201796,
  MOVE = 10827,
  PROSPER = 335290,
  FUNDROCK = 76666,
  KERNEL = 45259,
  UBT = 54739,
  DEMO = 32556,
  HECKOTRUST = 35492,
  RIVALW = 315222,
  SAXE = 105541,
  SNOWBALL = 385395, 
  GCQ = 416130,
  DISCO = 332516,
  QUAYCOVE = 405895,
  AFCAPITALPARTNERSLIMITED = 416093,
  CREMACAPITALLIMITED = 2,
  FOSTER = 347765
}

export enum ManagerAllowingInvdividualReport {
  CLEARY = 61106,
  BLISSETT = 201796,
  MOVE = 10827,
  PROSPER = 335290,
  FUNDROCK = 76666,
  COOLABAH = 301511,
}

export enum ManagerAllowBuySell {
  KERNEL = 45259,
  CLEARY = 61106,
  UBT = 54739,
  BLISSETT = 201796,
  DEMO = 32556,
  INVESTNOW = 4542,
  HECKOTRUST = 35492,
  RIVALW = 315222,
  SAXE = 105541,
  RUTHERFORDREDE = 338597, 
  SNOWBALL = 385395, 
  GCQ = 416130,
  RIVAL = 5361,
  EVIDENTIAL = 442029,
  MERRICKS = 442213,
  MUNRO = 442121,
  PGI = 450858,
  ISELECTSUPER = 441509
}

export enum ManagerAllowWithdrawals {
  RUTHERFORDREDE = 338597,
  DEMO = 32556
}

export enum PermissionModule {
  None = 1,
  CashSweep = 2,
  OrderManagement = 4,
  Custody = 8,
  PieManagement = 16,
  Qrops = 32,
  PortfolioViews = 64,
  MyDocuments = 128,
  Notifications = 256,
  KiwiSaver = 512,
}
